import Router from 'router';
import { useLazyGetProfileQuery } from 'api/authApi';
import { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { logOut, setProfile } from 'store/authSlice';
import { useDispatch } from 'react-redux';

function App() {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [getProfile] = useLazyGetProfileQuery()

  const initiateApp = async () => {
    try {
      let data = await getProfile().unwrap()
      if (data?.success && !!localStorage.getItem("token")) {
        dispatch(setProfile(data?.body))
      } else {
        dispatch(logOut())
      }
    } catch (error) {
      console.log("error initiateApp")
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    initiateApp()
  }, [])


  if (loading) {
    return (
      <Box display="flex" flex={1} height="100vh" justifyContent="center" alignItems="center" background="transparent">
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Router />
  );
}

export default App;
